// extracted by mini-css-extract-plugin
export var aiStarIcon = "_aj-4";
export var closeButton = "_aj-6";
export var dismissButton = "_aj-3";
export var editImageWithAiContainer = "_aj-8";
export var imageUploadWrapper = "_aj-7";
export var misspelledWord = "_aj-5";
export var spellCheckContainer = "_aj-2";
export var spin = "_aj-1";
export var spinning = "_aj-0";